module.exports = __webpack_public_path__ + "img/img77.2246eccf.png";